/** @format */
import { useState } from 'react';

import { MediaQuery } from '@toucan/client/global/application';

import { useIsomorphicLayoutEffect } from './helpers';

export const useMediaQuery = (
    query?: MediaQuery,

    /**
     * Initial value of the hook
     */
    initialValue: boolean = false
) => {
    const mediaQueryList: MediaQueryList | null =
        typeof window !== 'undefined' && query !== undefined
            ? window.matchMedia(query)
            : null;

    const [matches, setMatches] = useState(initialValue);

    useIsomorphicLayoutEffect(() => {
        /**
         * Store the result of the MediaQueryListEvent to the hook's internal
         * state.
         *
         * @param matches Whether the breakpoint matched
         */
        function handler({ matches }: MediaQueryListEvent) {
            setMatches(matches);
        }

        // Set initial value
        setMatches(Boolean(mediaQueryList?.matches));

        // Bind listener
        mediaQueryList?.addEventListener('change', handler);

        // Cleanup on un-mount
        return () => {
            mediaQueryList?.removeEventListener('change', handler);
        };
    }, []);

    return matches;
};
